import ListItem from '../ListItem'
import * as Styled from './styled'
import { listItemData } from './consts'

const MyProjectsBlock = () => (
  <Styled.MyProjectsBlock>
    <ul>
      <ListItem data={listItemData} />
    </ul>
  </Styled.MyProjectsBlock>
)

export default MyProjectsBlock
